import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

/**
 * Change who teaches individual lessons (admin only). `moves` is
 * [{ slotId, originDate, teacherId }]; all apply or none do. The server moves
 * the rotation rows and any existing lesson records in one transaction, and
 * pushes the teacher who gains lessons. functions/lessonReassign.js.
 */
export async function reassignLessons(moves) {
	const callable = httpsCallable(functions, 'reassignLessons');
	const res = await callable({
		moves: moves.map(({ slotId, originDate, teacherId }) => ({ slotId, originDate, teacherId })),
	});
	return res.data;
}
